import ImageUploadForm from "./sections/ImageUploadForm.jsx";
/* eslint-disable react-hooks/exhaustive-deps */

import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useCallback, useEffect, useRef, useState } from "react";


import Resizer from "react-image-file-resizer";
import { useSelector } from "react-redux";


const PIXEL_RATIO = 4;
const UploadImageHandler = ({ setData, setOpen, setPreviewH }) => {
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,

    aspect: 12 / 12,
    width: 100,
    height: 100,
  });
  const { token } = useSelector((state) => state.user);

  const [filenma, setFileNames] = useState();
  const [src, setSrc] = useState();
  const [filename, setfilename] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [croping, setCroping] = useState(false);
  const [resizing, setResizing] = useState(false);
  const [quality, setQuality] = useState(70);
  const [height, setHeight] = useState(500);
  const [ondrag, setOnDrag] = useState(false);

  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState("");
  const [blob, setBlob] = useState();
  const [blobType, setBlobType] = useState("");
  const [preview, setPreview] = useState();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setfilename();
    setPreview();
    setFileNames();
    setSrc()
    setFileError("");
  };
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const onLoad = useCallback((img) => {
    /*     imgRef.current = img;
     */
  }, []);
  useEffect(() => {
    if (filename) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrc(reader.result));
      reader.readAsDataURL(filename);
    }
  }, [filename]);

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }

    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * PIXEL_RATIO;
    canvas.height = crop.height * PIXEL_RATIO;

    ctx.setTransform(PIXEL_RATIO, 0, 0, PIXEL_RATIO, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    canvas.toBlob((blob) => {
      const previewUrl = URL.createObjectURL(blob);

      setBlob(blob);
      setPreview(previewUrl);
      setBlobType(blob.type);
    }, blobType);
  }, [completedCrop]);

  const resizedCropedImage = (image) => {
    if (filename.type === "image/svg+xml" || filename.type === "image/gif") {
      uploadImageHandler(image);
    } else {
      if (image !== null) {
        try {
          Resizer.imageFileResizer(
            image,
            Number(height),
            Number(height),
            "webp",
            Number(quality) > 100 ? 100 : Number(quality),
            0,
            (uri) => {
              const newn = new File([uri], `${filenma}.webp`, { type: "image/webp" });
              uploadImageHandler(newn);
            },
            "blob"
          );
        } catch (err) {}
      }
    }
  };
  const resizedCropedImage2 = (image) => {
    if (filename.type === "image/svg+xml" || filename.type === "image/gif") {
      uploadImageHandler(image);
    } else {
      if (image !== null) {
        try {
          Resizer.imageFileResizer(
            image,
            1800,
            1200,
            "webp",
            100,
            0,
            (uri) => {
              const newn = new File([uri], `${filenma}.webp`, { type: "image/webp" });
              uploadImageHandler(newn);
            },
            "blob"
          );
        } catch (err) {}
      }
    }
  };
  const handleUploadImage = () => {
    if (!filename) { setFileError("ابتدا یک تصویر انتخاب کنید."); return; }
    /*  var bl = blob ? blob : onDownloadCropClick(); */
    if (resizing && croping) {
      resizedCropedImage(blob ? blob : preview);
    } else if (resizing && !croping) {
      resizedCropedImage(preview);
    } else if (!resizing && croping) {
      resizedCropedImage2(blob ? blob : preview);
    } else {
      resizedCropedImage2(preview);
    }
  };

  const uploadImageHandler = (data) => {
    if (!(data instanceof Blob) || !data.size || !data.type.startsWith("image/")) {
      setFileError("فایل تصویر معتبر انتخاب کنید."); return;
    }
    getBase64(data);
    setData(data);
    setOpen(false);
  };
  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setPreviewH(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }
  const handleUploadImage2 = () => {
    uploadImageHandler(preview);
  };
  return (
    <ImageUploadForm fileError={fileError} setFileError={setFileError} value={value} handleChange={handleChange} a11yProps={a11yProps} TabPanel={TabPanel} setfilename={setfilename} setPreview={setPreview} setFileNames={setFileNames} setOnDrag={setOnDrag} ondrag={ondrag} src={src} loading={loading} handleUploadImage2={handleUploadImage2} setOpen={setOpen} croping={croping} filename={filename} crop={crop} setCrop={setCrop} setCompletedCrop={setCompletedCrop} imgRef={imgRef} onLoad={onLoad} previewCanvasRef={previewCanvasRef} setCroping={setCroping} resizing={resizing} setResizing={setResizing} setQuality={setQuality} quality={quality} setHeight={setHeight} height={height} handleUploadImage={handleUploadImage} />
  );
};
export default UploadImageHandler;
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
